import { useTranslation } from "@impero-com/common/utils/i18n";
import { PageSpinner } from "@impero-com/ui";

import { OrgApplicationBar } from "components/applicationBar/orgApplicationBar";
import { WebRoute } from "routes";

import { useNewMenu } from "../../navigation/useNewMenu";

import { ALL_ACTIVITIES_SCOPE } from "./consts";
import { ControlActivitiesList } from "./ControlActivitiesList";
import { useControlActivitiesListData } from "./useControlActivitiesListData";
import { useCopyLinkAction } from "./useCopyLinkAction";

export function ControlActivitiesListPage() {
    const { t } = useTranslation();
    const actions = useCopyLinkAction();
    const newMenu = useNewMenu();

    const {
        dataParams,
        dateFilters,
        archivedFilter,
        dto,
        tagCategories,
        isPending,
        isTableLoading,
    } = useControlActivitiesListData(ALL_ACTIVITIES_SCOPE);

    if (isPending || !dto) {
        return <PageSpinner />;
    }

    return (
        <OrgApplicationBar
            title={
                newMenu
                    ? {
                          breadCrumbs: [
                              {
                                  label: t("ControlManagement_ModuleTitle"),
                                  url: WebRoute.CONTROLS,
                              },
                          ],
                          title: t("Navigation_Activities"),
                      }
                    : t("ControlResults_Title")
            }
            actions={actions}
        >
            <ControlActivitiesList
                controlResultsDto={dto}
                tagCategories={tagCategories}
                dataParams={dataParams}
                dateFilters={dateFilters}
                archivedFilter={archivedFilter}
                isTableLoading={isTableLoading}
                scope={ALL_ACTIVITIES_SCOPE}
            />
        </OrgApplicationBar>
    );
}
